import { SmsAxios } from "@/main";

const set = (key) => (state, val) => {
  state[key] = val;
};

function initialState() {
  return {
    lines: [],
    total: 0,
    query: {},
    loading: false,
  };
}
const getStatus = (item) => {
  let text = "";
  if (item.state === "pending") {
    text = "منتظر فعالسازی";
  } else if (item.state === "deactivate") {
    text = "غیر فعال";
  }
  return text;
};

const route = "phone";

const getters = {
  lines: (state) => state.lines,
  total: (state) => state.total,
  loading: (state) => state.loading,
};
const getColor = (item) => {
  let color = "#000000";
  if (item.user_id === null) {
    color = "#1565c0";
  }
  if (
    item.user_id === null &&
    (item.subnumber.phone === "5004" || item.subnumber.phone === "5002")
  ) {
    color = "#2e7d32";
  }

  if (item.user_id !== 88 && item.user_id !== null) {
    color = "#6a1b9a";
  }
  if (item.subnumber.phone === "12345") {
    color = "#c62828";
  }

  if (item.category?.title === "سفارشی" && item.user_id !== 88) {
    color = "#ef6c00";
  }

  if (item.user_id === 88) {
    color = "#424242";
  }

  return color;
};

const actions = {
  fetchIndexData({ commit }) {
    commit("setLoading", true);
    SmsAxios.get("phone")
      .then((response) => {
        const reformat = response.data.data.map((item) => {
          const isNews = item.subnumber.phone === "12345";

          let label = "";

          if (isNews) {
            label += " ارسال خبری ";
          } else {
            label += item.subnumber.phone + item.numbers + " ";
          }
          const userName = item.user
            ? ` ${item.user.name.trim() || ""} ${
                item.user.lastName.trim() || ""
              } `
            : "";
          label += userName;
          label += ` - ${item.category?.title} `;

          label +=
            getStatus(item) === "" ? getStatus(item) : ` (${getStatus(item)})`;
          const coloredText = `<span>${label.trim()}</span>`;

          return {
            value: item.subnumber.phone + item.numbers,
            text: coloredText,
            category_id: item.category_id,
          };
        });

        commit("setLines", reformat);
        commit("setTotal", response.data.total || reformat.length);
      })
      .catch((err) => console.error("خطا در بارگذاری شماره‌ها:", err))
      .finally(() => commit("setLoading", false));
  },
};
const mutations = {
  setLines: set("lines"),
  setTotal: set("total"),
  setQuery(state, query) {
    query.page = (query.offset + query.limit) / query.limit;
    state.query = query;
  },
  setLoading: set("loading"),
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
